const TIME_BUCKET_KEYS = {
  LESS_THEN_EQUAL_TO_THIRTY_MIN: "≤ 30 Min",
  MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR: "30–60 Min",
  MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR: "1–2 Hr",
  MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR: "2–3 Hr",
  MORE_THEN_THREE_HOURS: "> 3 Hr",
};

export const buildAllLevelData = (rawData) => {
  const allLevelData = [];

  /* ---------------- LEVEL 1 : MONTH ---------------- */
  const monthMap = {};

  rawData.forEach((row) => {
    const month = `${row.PDD_MONTH}`;

    if (!monthMap[month]) {
      monthMap[month] = {
        total: 0,
        lobbies: {},
      };
    }

    monthMap[month].total += row.TOTAL_CASES;

    const lobbyKey = `${row.PDD_LOBBY}-${month}`;
    monthMap[month].lobbies[lobbyKey] = row;
  });

  const monthData = Object.entries(monthMap).map(([month, info]) => [
    month,
    info.total,
    "months",
    month,
  ]);

  allLevelData.push(monthData);

  /* ---------------- LEVEL 2 : LOBBY ---------------- */
  Object.entries(monthMap).forEach(([month, info]) => {
    const lobbyData = Object.values(info.lobbies).map((row) => {
      const lobbyId = `${row.PDD_LOBBY}-${month}`;

      return [row.PDD_LOBBY_NAME, row.TOTAL_CASES, month, lobbyId];
    });

    allLevelData.push(lobbyData);
  });

  /* ---------------- LEVEL 3 : TIME BUCKETS ---------------- */
  Object.entries(monthMap).forEach(([month, info]) => {
    Object.values(info.lobbies).forEach((row) => {
      const lobbyId = `${row.PDD_LOBBY}-${month}`;
      const bucketData = Object.entries(TIME_BUCKET_KEYS).map(
        ([key, value]) => [value, row[key] || 0, lobbyId]
      );

      allLevelData.push(bucketData);
    });
  });

  return allLevelData;
};
